import React from 'react'

import BasicHeadSeo from '@/components/basicHeadSeo'
import Header from '@/components/newHeader/Header'
import Footer from '@/components/newFooter/newFooter'
import {
  FetchPetInsurance,
  InsuranceHeaderBanner,
} from '@/components/insurance'

import { ROBOTS_META } from 'const'

export default function Insurance() {
  return (
    <div>
      <BasicHeadSeo
        title="Insurance | MawooPets.com"
        description=""
        url={`${process.env.NEXT_PUBLIC_ROOT_URL}/insurance`}
        image={`${process.env.NEXT_PUBLIC_ROOT_URL}/mawoo_social_1600x906.png`}
        content={ROBOTS_META}
      />

      <Header />
      <InsuranceHeaderBanner />
      <FetchPetInsurance />
      <Footer />
    </div>
  )
}
